import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Logo, Footer } from "@/components/Layout";
import { FactBanner } from "@/components/FactBanner";
import { Button } from "@/components/ui/button";
import { ArrowRight, Check } from "lucide-react";

const POINTS = [
  "Instant feedback system designed by tutors at elite UK universities.",
  "Tailored specifically for international applicants.",
  "Focused on what admissions tutors actually look for.",
  "Ethical feedback that helps you say it in your own words.",
  "Helps you build confidence in your personal statement.",
];

export default function Landing() {
  return (
    <div className="min-h-screen flex flex-col bg-sand">
      <main className="flex-1 flex flex-col">
        <section className="flex-1 grid place-items-center">
          <div className="max-w-2xl mx-auto px-6 sm:px-8 py-16 sm:py-24 text-center">
            <motion.div
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.55, ease: "easeOut" }}
            >
              <div className="flex justify-center" data-testid="brand-mark">
                <Logo big />
              </div>

              <h1 className="mt-8 font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-tight text-ink">
                Get your UCAS personal statement right.
              </h1>

              <ul className="mt-10 space-y-3 text-left max-w-xl mx-auto" data-testid="home-points">
                {POINTS.map((p, i) => (
                  <motion.li
                    key={p}
                    initial={{ opacity: 0, y: 8 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: 0.15 + i * 0.08 }}
                    className="flex items-start gap-3 text-base sm:text-lg text-ink-soft leading-relaxed"
                  >
                    <span className="mt-1 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-forest/15 text-forest">
                      <Check className="h-3 w-3" strokeWidth={3} />
                    </span>
                    {p}
                  </motion.li>
                ))}
              </ul>

              <div className="mt-12 flex flex-col items-center gap-3 w-full max-w-xs mx-auto">
                <Button
                  asChild
                  data-testid="get-feedback-cta"
                  className="w-full justify-center bg-clay hover:bg-clay-hover text-white rounded-lg px-8 py-6 text-base font-medium shadow-sm transition-colors"
                >
                  <Link to="/analyse">
                    Get instant feedback now
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Link>
                </Button>
                <Button
                  asChild
                  variant="outline"
                  data-testid="explore-guides-cta"
                  className="w-full justify-center bg-transparent border-forest text-forest hover:bg-forest/10 hover:text-forest rounded-lg px-8 py-6 text-base font-medium transition-colors"
                >
                  <Link to="/guides">
                    Explore our expert guides
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Link>
                </Button>
              </div>
            </motion.div>
          </div>
        </section>

        <FactBanner />
      </main>

      <Footer />
    </div>
  );
}
